import RichText from '@/components/ui/RichText/RichText';

type HeadingProps = {
  content: any;
  sizeClassName?: string;
  colorClassName?: string;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export default function Heading({
  content,
  sizeClassName = 'text-2xl sm:text-3xl lg:text-4xl',
  colorClassName = 'text-primary',
  className = '',
  ...rest
}: HeadingProps) {
  return (
    <RichText
      className={['font-bold', colorClassName, sizeClassName, className].join(
        ' ',
      )}
      {...rest}
    >
      {content}
    </RichText>
  );
}
